module.exports = __webpack_public_path__ + "img/podcast-banner-bg.72a8dc61.svg";